
export class FleetStatePredictor {
    constructor(location, fuel) {
        this.fuel = fuel;
        this.estimated_fuel = fuel;
        this.time_stamp = Date.now();
        this.location = location;
    }

    addCertainFuel(fuel) {
        this.fuel += fuel;
        this.estimated_fuel += fuel;
    }

    removeCertainFuel(fuel) {
        this.fuel -= fuel;
        this.estimated_fuel -= fuel;
    }

    addEstimatedFuel(fuel) {
        this.estimated_fuel += fuel;
    }

    isEnough() {
        return this.fuel >= 0;
    }

    maybeEnough() {
        return this.estimated_fuel >= 0;
    }

    addTime(time) {
        this.time_stamp += time;
    }

    getTime(time) {
        return this.time_stamp;
    }

    updateLocation(location) {
        this.location = location;
    }

    getLocation() {
        return this.location;
    }
}